export default __webpack_public_path__ + "static/media/img_6.1a8e49be.png";